import React from 'react';
import { Typography, Stack, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import chileFooter from '../../constants/footer/chile-footer';
import ContactInformationStack from '../../components/stacks/ContactInformationStack';
import SocialMediaStack from './components/SocialMediaStack';
import {
  containerStack,
  leftStack,
  textTypography,
  clickableTypography,
} from './styles/footer-chile.styles';
import { STACK_START_COLUMN_DIRECTION } from '../../constants/mui-components';

function FooterChile() {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Stack sx={containerStack(theme)}>
      <Stack className={STACK_START_COLUMN_DIRECTION} sx={leftStack}>
        <Typography variant="small_2" sx={textTypography(theme)}>
          {chileFooter.slogan}
        </Typography>
        <Typography
          variant="small_2"
          sx={clickableTypography(theme)}
          onClick={() => navigate(chileFooter.tyc.navigateTo)}
        >
          {chileFooter.tyc.text}
        </Typography>
        <Typography
          variant="small_2"
          sx={textTypography(theme)}
        >
          {chileFooter.legalNotice}
        </Typography>
      </Stack>
      {chileFooter.contactInformation.map((contact) => (
        <ContactInformationStack
          key={contact.title}
          title={contact.title}
          description={contact.phone || contact.address}
          email={contact.email}
          navigateTo={contact.navigateTo}
        />
      ))}
      <SocialMediaStack />
    </Stack>
  );
}
export default FooterChile;
